import { APIManager, axios } from 'shared/manager';
import { ManageAccessEnd } from 'shared/Constants';

/**
 * Sends a get request fo fetch members in access management
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const getMembers = async (data: GetMemberBody): Promise<any> =>
    APIManager.sendGetWithBody(ManageAccessEnd.GET_MEMBERS, data, true, axios);

/**
 * Sends a GET request fo fetch available roles in access management
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const getRoles = async (): Promise<any> =>
    APIManager.sendGet(ManageAccessEnd.GET_ROLES, true, {}, {}, axios);

/**
 * Send a POST request to invite member
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const sendInvitationMember = async (data: InvitationMemberData): Promise<any> =>
    APIManager.sendPost(
        ManageAccessEnd.SEND_INV_MEMBERS,
        data,
        true,
        {},
        {},
        axios
    );

/**
 * Send a PATCH request to change member
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const sendPatchMember = async (data: MemberData): Promise<any> =>
    APIManager.sendPatch(
        ManageAccessEnd.PATCH_MEMBER,
        data,
        true,
        {},
        {},
        axios
    );
/**
 * Send a PATCH request to change member availability
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const sendPatchToEnableMember = async (
    data: MemberDataAvailability
): Promise<any> =>
    APIManager.sendPatch(
        ManageAccessEnd.PATCH_MEMBER_CONFIG,
        data,
        true,
        {},
        {},
        axios
    );

/**
 * Send a DELETE request to remove member
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const deleteMember = async (data: MemberDataRemoveable): Promise<any> =>
    APIManager.sendDelete(
        `${ManageAccessEnd.DELETE_MEMBER}/${data.userId}`,
        true,
        {},
        {},
        axios
    );

/**
 * Sends a get request fo fetch members in access management
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const getMembersAuditFile = async (data: GetMemberAuditFile): Promise<any> =>
    APIManager.sendGetWithBody(
        ManageAccessEnd.GET_MEMBERS_AUDIT_FILE,
        data,
        true,
        axios
    );

export const ManageAccessService = {
    getMembers,
    getRoles,
    sendInvitationMember,
    sendPatchMember,
    sendPatchToEnableMember,
    deleteMember,
    getMembersAuditFile,
};
